import create from './store/create';
import detailStorageReport from './store/detail';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('storage-reports$create', create);
  store.registerModule('storage-reports$detail', detailStorageReport);
};
